import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[hfSendOnEnter]' })
export class SendOnEnterDirective {
  @Output() hfSendOnEnter = new EventEmitter<void>();

  @HostListener('keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    // @ts-ignore
    if ((e as any).isComposing) return;

    const isEnter = e.key === 'Enter';
    const shift = e.shiftKey;

    if (isEnter && !shift) {
      e.preventDefault();
      this.hfSendOnEnter.emit();
    }
  }
}
